import { useEffect, useState } from "react";
import { MessageCircle, X, Megaphone } from "lucide-react";

const GROUP_URL = "https://chat.whatsapp.com/GmrucJkdLhMGRZjM02iI6d";
const KEY = "wa_group_popup_seen";
const EVERY_MS = 24 * 60 * 60 * 1000;

export default function WhatsAppGroupPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let last = 0;
    try { last = Number(localStorage.getItem(KEY) || 0); } catch {}
    if (Date.now() - last < EVERY_MS) return;
    const t = setTimeout(() => setOpen(true), 1200);
    return () => clearTimeout(t);
  }, []);

  function close() {
    try { localStorage.setItem(KEY, String(Date.now())); } catch {}
    setOpen(false);
  }

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[90] grid place-items-center bg-black/75 p-4" onClick={close} data-testid="wa-group-popup">
      <div className="relative w-full max-w-sm rounded-2xl border border-emerald-500/40 bg-[#0a0a0a] p-6 text-center shadow-[0_0_40px_rgba(16,185,129,0.25)]" onClick={(e) => e.stopPropagation()}>
        <button onClick={close} aria-label="Cerrar" data-testid="wa-group-close" className="absolute top-3 right-3 p-1.5 rounded-md text-neutral-400 hover:text-white hover:bg-white/10">
          <X className="w-5 h-5" />
        </button>
        <div className="w-16 h-16 mx-auto rounded-full grid place-items-center bg-emerald-500/15 border border-emerald-500/40">
          <Megaphone className="w-8 h-8 text-emerald-400" />
        </div>
        <h2 className="font-display text-3xl tracking-wider text-white mt-4">¡Unite al grupo!</h2>
        <p className="text-sm text-neutral-300 mt-2">
          Sumate a nuestro grupo de WhatsApp y enterate primero de <span className="text-emerald-400">comunicados, avisos y promos</span> exclusivas.
        </p>
        <a href={GROUP_URL} target="_blank" rel="noopener noreferrer" onClick={close} data-testid="wa-group-join"
          className="mt-5 w-full inline-flex items-center justify-center gap-2 px-5 py-3.5 rounded-lg bg-emerald-500 hover:bg-emerald-400 text-black font-bold transition-colors">
          <MessageCircle className="w-5 h-5" /> Unirme al grupo
        </a>
        <button onClick={close} data-testid="wa-group-later" className="mt-3 text-xs text-neutral-500 hover:text-neutral-300">Ahora no</button>
      </div>
    </div>
  );
}
